import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { toast } from "sonner";

const ViewContext = createContext(null);

export function ViewProvider({ children }) {
  const [mode, setMode] = useState("technical"); // "recruiter" | "technical"
  const prevMode = useRef(mode);

  useEffect(() => {
    if (prevMode.current === mode) return;
    prevMode.current = mode;
    toast(mode === "recruiter" ? "60-Second Recruiter View" : "Technical Deep Dive", {
      description:
        mode === "recruiter"
          ? "Condensed view: positioning, impact, top projects and contact."
          : "Full view: architecture, methodology, datasets and interactive labs.",
    });
  }, [mode]);

  const switchMode = useCallback((next) => {
    setMode(next);
  }, []);

  const goTo = useCallback(
    (id) => {
      if (mode === "recruiter") setMode("technical");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });
    },
    [mode]
  );

  const value = useMemo(
    () => ({ mode, isRecruiter: mode === "recruiter", switchMode, goTo }),
    [mode, switchMode, goTo]
  );
  return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>;
}

export function useView() {
  return useContext(ViewContext);
}
